import { ENGINE_VERSION } from '../engine';
import type { ProjectDoc } from '../model/types';

export const FORMAT = 'extent-project';

export interface ProjectFile {
  format: typeof FORMAT;
  formatVersion: 1;
  exportedAt: string;
  engineVersion: string;
  doc: ProjectDoc;
}

export function projectFile(doc: ProjectDoc, now = new Date()): ProjectFile {
  return { format: FORMAT, formatVersion: 1, exportedAt: now.toISOString(), engineVersion: ENGINE_VERSION, doc };
}

/** Reads a project file and checks its shape. Returns a message saying what is wrong otherwise. */
export function readProjectFile(text: string): { doc: ProjectDoc } | { error: string } {
  let data: unknown;
  try { data = JSON.parse(text); } catch { return { error: 'This file is not valid JSON.' }; }
  const f = data as Partial<ProjectFile>;
  if (f?.format !== FORMAT) return { error: 'This is not an Extent project file.' };
  if (f.formatVersion !== 1) return { error: `Project file version ${String(f.formatVersion)} is not supported by this version of Extent.` };
  const d = f.doc as Partial<ProjectDoc> | undefined;
  if (!d || d.schemaVersion !== 1) return { error: 'The project inside the file has an unsupported version.' };
  for (const k of ['substances', 'areas', 'sources', 'equipment'] as const) {
    if (!Array.isArray(d[k])) return { error: `The project file is missing its ${k}.` };
  }
  if (!d.meta?.name || !d.settings) return { error: 'The project file is missing its name or settings.' };
  return { doc: { ...(d as ProjectDoc), objects: Array.isArray(d.objects) ? d.objects : [] } };
}

export const slug = (s: string) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'project';
